import React from 'react';

const WhyChooseUs = () => {
  const features = [
    {
      icon: '🗺️',
      title: 'Tailor-made trips',
      description: 'Customized itineraries designed just for you'
    },
    {
      icon: '✅',
      title: 'Hassle-free bookings',
      description: 'Easy and smooth booking process'
    },
    {
      icon: '🌟',
      title: 'Unforgettable adventures',
      description: 'Create memories that last a lifetime'
    },
    {
      icon: '👨‍💼',
      title: 'Expert guidance',
      description: 'Led by Er. Surya Pratap Singh (NIT, 2015)'
    }
  ];

  return (
    <section className="why-choose-us">
      <div className="section-title">
        <h2>Why Choose RedGoTrip?</h2>
        <p>Your journey, our expertise!</p>
      </div>
      <div className="features-grid">
        {features.map((feature, index) => (
          <div className="feature-card" key={index}>
            <div className="feature-icon">{feature.icon}</div>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;